import { render } from "./Topbar.vue?vue&type=template&id=398f0d0f&scoped=true&ts=true"
import script from "./Topbar.vue?vue&type=script&lang=ts"
export * from "./Topbar.vue?vue&type=script&lang=ts"

import "./Topbar.vue?vue&type=style&index=0&id=398f0d0f&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398f0d0f"]])

export default __exports__